import React from 'react';
import Layout from '../components/Layout';
import StageMenu from '../components/StageMenu';
import '../assets/styles/components/Stages.sass';

class StageTwo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            content: '',
            title: ''
        }
    }
    
    componentDidMount() {
        
        fetch('https://legendofeldorado.com/2018/api/stage/37')
        .then(res => res.json())
        .then(
        (res) => {
            this.setState({
                isLoaded: true,
                content: res.content_es,
                title: res.title_es
            });

            document.getElementById('contenido').innerHTML = this.state.content
        },
        
        (error) => {
            this.setState({
                isLoaded: true,
                error
            });
        }
        )

        document.getElementById('stageEtapa2').classList.add('active')
        document.getElementById('stages').classList.add('active')
    }

    componentWillUnmount() {
        document.getElementById('stageEtapa2').classList.add('active')
        document.getElementById('stages').classList.remove('active')
    }

    render() {
        return(
            <Layout>
                <StageMenu/>
                <div className="row">
                    <div className="container">
                        <div className="row" id="contenido"></div>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default StageTwo;